import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Plane, Hotel, Coffee, Users, Briefcase, Star } from 'lucide-react';

const Voyages = () => {
  const serviceCategories = [
    {
      icon: Plane,
      title: 'Transport & Logistique',
      services: [
        'Billets corporate',
        'Chauffeurs privés & transferts',
        'Suivi des vols et gestion des changements',
        'Coordination multi-destinations'
      ]
    },
    {
      icon: Hotel,
      title: 'Hébergement',
      services: [
        'Réservations d\'hôtels business et luxe',
        'Tarifs corporate et upgrades selon disponibilités',
        'Gestion des check-in/check-out'
      ]
    },
    {
      icon: Coffee,
      title: 'Restauration & Lifestyle',
      services: [
        'Réservations restaurants business',
        'Experiences premium pour dirigeants',
        'Service sur mesure selon les préférences'
      ]
    },
    {
      icon: Briefcase,
      title: 'Affaires & Réunions',
      services: [
        'Salles de réunion',
        'Conférences & équipements techniques',
        'Solutions audiovisuelles et interprétariat'
      ]
    },
    {
      icon: Star,
      title: 'Services VIP',
      services: [
        'Fast-track',
        'Protocoles aéroportuaires',
        'Accès lounge',
        'Assistance personnelle 24/7'
      ]
    }
  ];

  const idealFor = [
    'Directions générales',
    'Roadshows',
    'Voyages multi-pays',
    'Missions stratégiques',
    'Déplacements de groupes',
    'Visites de sites industriels, plantations, filiales'
  ];

  return (
    <div style={{ background: 'var(--bg-page)' }}>
      {/* Hero Section with Image */}
      <section style={{
        position: 'relative',
        padding: '180px 0 100px',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0
        }}>
          <img
            src="https://images.unsplash.com/photo-1578758803946-2c4f6738df87"
            alt="Business Executive Travel"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute'
            }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.88), rgba(26, 28, 27, 0.75))'
          }}></div>
        </div>

        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          position: 'relative',
          zIndex: 1
        }}>
          <div className="caption" style={{
            color: 'var(--brand-primary)',
            marginBottom: '20px'
          }}>
            Voyages d'Affaires Clés-en-Main
          </div>
          <h1 className="heading-1" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px',
            maxWidth: '900px'
          }}>
            Vos voyages d'affaires organisés de A à Z
          </h1>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            maxWidth: '700px',
            marginBottom: '40px'
          }}>
            Nous coordonnons vos déplacements professionnels dans le moindre détail.
          </p>
          <Link to="/contact" className="btn-primary">
            Demander un devis <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Introduction */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <h2 className="heading-3" style={{
              color: 'var(--brand-primary)',
              marginBottom: '30px',
              textAlign: 'center'
            }}>
              Pourquoi un service clés-en-main ?
            </h2>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              L'organisation d'un voyage d'affaires exige disponibilité, précision et coordination continue.
            </p>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              Les entreprises ne devraient pas mobiliser leurs équipes pour cela : c'est notre métier.
            </p>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              textAlign: 'center'
            }}>
              L'Agence gère intégralement vos déplacements professionnels, en collaboration avec vos équipes lorsque c'est nécessaire, et en vous garantissant un service exclusif, non standardisé et parfaitement maîtrisé.
            </p>
          </div>
        </div>
      </section>

      {/* Services Included */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Services inclus
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '40px'
          }}>
            {serviceCategories.map((category, index) => {
              const Icon = category.icon;
              return (
                <div key={index} style={{
                  background: 'var(--bg-card)',
                  padding: '40px',
                  border: '1px solid var(--border-medium)',
                  transition: 'transform 0.3s ease, background-color 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.backgroundColor = 'var(--secondary-olive)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = 'var(--bg-card)';
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid var(--brand-primary)',
                    borderRadius: '50%',
                    marginBottom: '20px'
                  }}>
                    <Icon size={28} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-4" style={{
                    color: 'var(--brand-primary)',
                    marginBottom: '20px',
                    textTransform: 'uppercase',
                    fontSize: '1rem'
                  }}>
                    {category.title}
                  </h3>
                  <ul style={{
                    listStyle: 'none',
                    padding: 0
                  }}>
                    {category.services.map((service, idx) => (
                      <li key={idx} style={{
                        marginBottom: '10px',
                        paddingLeft: '20px',
                        position: 'relative',
                        color: 'var(--text-secondary)',
                        fontSize: '0.95rem'
                      }}>
                        <span style={{
                          position: 'absolute',
                          left: 0,
                          color: 'var(--brand-primary)'
                        }}>•</span>
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Ideal For */}
      <section style={{
        padding: '100px 0',
        background: 'var(--secondary-olive)',
        borderTop: '1px solid var(--border-medium)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Idéal pour
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px'
          }}>
            {idealFor.map((item, index) => (
              <div key={index} style={{
                background: 'var(--bg-card)',
                padding: '30px',
                border: '1px solid var(--border-medium)',
                textAlign: 'center',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <div className="heading-4" style={{
                  color: 'var(--brand-primary)',
                  fontSize: '1.1rem'
                }}>
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Engagement Section */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          textAlign: 'center'
        }}>
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '60px 40px',
            background: 'var(--bg-card)',
            border: '2px solid var(--brand-primary)'
          }}>
            <Users size={48} color="var(--brand-primary)" style={{ marginBottom: '20px' }} />
            <h3 className="heading-3" style={{
              color: 'var(--brand-primary)',
              marginBottom: '20px'
            }}>
              Notre Engagement
            </h3>
            <p className="body-large" style={{
              color: 'var(--text-secondary)'
            }}>
              Chaque passager bénéficie d'un suivi humain et constant, disponible 24h/24 et 7j/7.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          textAlign: 'center'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px'
          }}>
            Prêt à voyager sans stress ?
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '40px',
            maxWidth: '600px',
            margin: '0 auto 40px'
          }}>
            Laissez-nous gérer tous les aspects de vos déplacements professionnels pendant que vous vous concentrez sur vos objectifs.
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/contact" className="btn-primary">
              Demander un devis <ArrowRight size={20} />
            </Link>
            <a href="tel:+243841223949" className="btn-secondary">
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Voyages;